export default __webpack_public_path__ + "static/media/Iconoclast's Crown.4e1b1122.jpg";